import { createContext } from "react";

/**
 * Whether the person has narrowed the list they are looking at, and what its
 * rows are called (#642).
 *
 * `SectionPage` fills it; `NoMatches` reads it. A list that is simply empty —
 * no transfers made yet, no damaged returns — used to say "Nothing matches.
 * Clear filters" under a filter bar with nothing in it, which reads as a
 * broken filter. With nothing narrowed the same component now says
 * "No transfers yet" instead, so none of the thirty lists that draw it has to
 * know the difference.
 *
 * `narrowed` is the person's own filter or typed search. A section's standing
 * filter (Vendors, Unfulfilled) is not theirs to clear, so it does not count.
 */
export interface ListState {
  narrowed: boolean;
  /** Plural, lower case: "transfers", "damaged returns". */
  things: string;
  /** Overrides "No {things} yet" where that sentence reads badly. */
  nothingYet?: { title: string; description?: string };
}

/** Outside a section nothing is known, so a list keeps the filtered wording. */
export const ListStateContext = createContext<ListState | null>(null);

/** The heading an empty list shows when nothing has been narrowed. */
export function nothingYetTitle(state: ListState): string {
  return state.nothingYet?.title ?? `No ${state.things} yet`;
}
